/*
 * @Author: zhujian 
 * @Date: 2019-09-16 15:29:41 
 * @Last Modified by: zhujian
 * @Last Modified time: 2019-09-21 15:11:42
 */

import Lottie from 'react-lottie';
import React from 'react';
import * as loading from './data.json';
import * as test from './test/data.json';
import './DefaultIcon.less';

class DefaultIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        loading,
        test
      }
    };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: this.state.data[this.props.type].default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    return (
      <div style={this.props.style} className="DefaultIcon" key="icon">
        <Lottie
          options={defaultOptions}
          width={250}
          isStopped={false}
          isPaused={false}
        />
        <p>{this.props.title}</p>
      </div>
    );
  }
}

export default DefaultIcon;